import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconDragIndicatorComponent } from "./med-icon-drag-indicator.component";

@NgModule({
  declarations: [
    MedIconDragIndicatorComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconDragIndicatorComponent,
  ],
})
export class MedIconDragIndicatorModule { }
